module.exports = __webpack_public_path__ + "public/img/promo-2.2a74ce89.jpg";